import { Component, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from '@huge-monorepo/portal/config';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { emailValidator } from 'libs/portal/src/directives/validator.directive';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  ScreenSize = ScreenSize;
  // @Output() userAdded: EventEmitter<User> = new EventEmitter<User>();
  // @Input() register: boolean = false;
  customers: any[] = [];
  aggregates: any[] = [];
  selectedCustomers: any[] = [];
  selectedAggregates: any[] = [];
  selectedRoles: any[] = [];
  aggregatesToggled = false;
  currentCustomerPage = 0;
  dataAccesses: any;
  user: any;
  userAccesses: any;
  subCustomers = [];
  userID = 0;
  loggedInUserID = 0;
  loading = true;
  cdrTableOptions: CardTableOptions = {
    titleProperty: 'TradingName',
    subTitleProperty: 'AccountNumber',
    textSize: 'regular',
    additionalProperty: 'HQAccountNumber',
    rowId: 'ID',
    //contentProperty : 'content',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'AggregateID', 'AggregateTypeID', 'CustomerTypeID', 'Status', 'Reference', 'IsActive', 'Email', 'HQAccountNumber', 'UsageThreshold', 'selected'],
    stylePropertyPrefix: 'devices',
    clickableFlexCard: false,
  };

  aggregateHeaders: CardTableHeader[] = [
    {
      ID: 'Description',
      Text: 'Description',
    },
  ];

  customerHeaders: CardTableHeader[] = [
    {
      ID: 'AccountNumber',
      Text: 'Account',
      Width: 300
    },
    {
      ID: 'TradingName',
      Text: 'Name',
      Width: 100
    },
  ];

  emailControl = new UntypedFormControl('', [Validators.required, Validators.minLength(4), emailValidator()]);
  nameControl = new UntypedFormControl('', [Validators.required]);
  surnameControl = new UntypedFormControl('', [Validators.required]);

  validations_form = this.formBuilder.group({
    emailControl: this.emailControl,
    nameControl: this.nameControl,
    surnameControl: this.surnameControl,
  });

  validation_messages = {
    nameControl: [{ type: 'required', message: 'Name is required.' }],
    surnameControl: [{ type: 'required', message: 'Surname is required.' }],
    emailControl: [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Enter valid email.' },
    ],
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private genericService: GenericService,
    private toastService: ToastrService,
    private endpoints: Endpoints,
    private titleService: TitleService,
    private auth: UserRightsService,
    private route: ActivatedRoute,
    private router: Router,
    private routes: Routes,
    @Optional() private dialogRef: MatDialogRef<AddUserComponent>,
  ) {
    this.genericService.POST(this.endpoints.GET_GROUP_DATA_ACCESSES, { GroupID: this.auth.GetGroupID() }).subscribe((resp) => {
      this.dataAccesses = resp['body'];
      if (this.dataAccesses.Customers.length == 0 && this.dataAccesses.Aggregates.length > 0) {
        this.aggregatesToggled = true;
      }

      const tempUserID = this.route.snapshot.paramMap.get('id');
      if (tempUserID != null) {
        this.userID = parseInt(tempUserID);
        console.log(this.userID);
        genericService.GET(endpoints.GET_USER(this.userID)).subscribe((user) => {
          setTimeout(() => {
            this.user = user['body'];
            console.log(this.user);
            this.fillUserDetails();
            this.loading = false;
          });
          console.log(this.dataAccesses);

        });
      } else {
        this.loading = false;
      }

    });
  }

  async closeModal(isCancelled: boolean) {
    this.dialogRef.close(isCancelled);
  }

  ngOnInit() {
    this.loggedInUserID = this.auth.GetUID();
  }

  fillUserDetails() {
    this.titleService.pageTitle = 'Edit User';
    this.emailControl = new UntypedFormControl(`${this.user.Email}`, [Validators.required, Validators.email]);
    this.nameControl = new UntypedFormControl(`${this.user.Name}`, [Validators.required]);
    this.surnameControl = new UntypedFormControl(`${this.user.Surname}`, [Validators.required]);

    this.validations_form = this.formBuilder.group({
      emailControl: this.emailControl,
      nameControl: this.nameControl,
      surnameControl: this.surnameControl,
    });

    if (this.dataAccesses.Customers.length > 0) {
      if (this.user.DataAccesses) {
        this.user.DataAccesses.forEach((access) => {
          let accessIndex;
          for (let index = 0; index < this.dataAccesses.Customers.length; index++) {
            if (this.dataAccesses.Customers[index].ID == access.CustomerID) {
              this.selectedCustomers.push({
                ID: access.ID,
                CustomerID: access.CustomerID,
                AggregateID: null,
                EnableSubCustomers: access.EnableSubCustomers,
              });
              accessIndex = index;
            }
          }

          if (accessIndex != null) {
            this.dataAccesses.Customers[accessIndex].selected = true;
            this.dataAccesses.Customers[accessIndex].subCustomersToggled = access.EnableSubCustomers;
          }
        });
      }
    } else if (this.dataAccesses.Aggregates.length > 0) {
      if (this.user.DataAccesses) {
        this.user.DataAccesses.forEach((access) => {
          let accessIndex;
          for (let index = 0; index < this.dataAccesses.Aggregates.length; index++) {
            if (this.dataAccesses.Aggregates[index].ID == access.AggregateID) {
              this.selectedAggregates.push({
                ID: access.ID,
                CustomerID: null,
                AggregateID: access.AggregateID,
                EnableSubCustomers: false,
              });
              accessIndex = index;
            }

            if (accessIndex != null) {
              this.dataAccesses.Aggregates[accessIndex].selected = true;
            }
          }
        });
      }
    }

    if (this.user.UserAccessRoles == null) {
      this.user.UserAccessRoles = [];
    }
  }

  addUser() {
    const isFormInputValid =
      this.emailControl.value !== '' &&
      this.nameControl.value !== '' &&
      this.surnameControl.value !== '' &&
      this.emailControl.errors == null &&
      this.nameControl.errors == null &&
      this.surnameControl.errors == null;

    if (isFormInputValid) {
      const newUser: any = {
        Name: this.nameControl.value,
        Surname: this.surnameControl.value,
        Email: this.emailControl.value,
        Accesses: [],
        SendEmail: true,
      };

      if (this.selectedCustomers.length > 0) {
        newUser.Accesses = this.selectedCustomers;
      } else if (this.selectedAggregates.length > 0) {
        newUser.Accesses = this.selectedAggregates;
      }

      const filteredSelectedRoles = this.selectedRoles.filter((x) => x.level > 0);
      newUser.AccessRoleIDs = filteredSelectedRoles.map((role) => {
        return role.AccessDomainRoleID;
      });

      if (this.user == null) {
        // ADD
        console.log('newUser', newUser);
        this.genericService.POST(this.endpoints.CREATE_USER, newUser).subscribe((resp) => {
          if (resp['status'] == 200) {
            this.toastService.success('User added successfully');
            this.router.navigate([this.routes.UserManagement]);
          }
        });
      } else {
        // EDIT
        newUser['ID'] = this.user.ID;
        console.log('newuser', newUser);
        this.genericService.PUT(this.endpoints.UPDATE_USER(this.user.ID), newUser).subscribe(
          {
            next: (resp) => {
              if (resp == null) {
                if (this.user?.UserID == this.loggedInUserID) {
                  this.auth.Logout();
                  this.toastService.info('Please login again for the changes to reflect.', 'Login Required', { timeOut: 5000 });
                } else {
                  this.router.navigate([this.routes.UserManagement]);
                }
              } else {
                this.toastService.success('User updated successfully');
                this.router.navigate([this.routes.UserManagement]);
              }
            }
          });

      }
    }
  }


  entitySelected(ev) {
    if (ev.row.AggregateID === null) {
      const result = this.selectedCustomers.find((u1) => u1.CustomerID == ev.row.ID);
      const record = this.dataAccesses.Customers.find((u1) => u1.ID == ev.row.ID);

      if (ev.checked && !result) {
        let existingObj;
        if (this.user.dataAccesses != null) {
          existingObj = this.user.DataAccesses.find((obj) => {
            return obj.CustomerID == record.ID;
          });
        }

        const customerAccess = {
          CustomerID: record.ID,
          AggregateID: null,
          EnableSubCustomers: false,
        };

        if (existingObj != null) {
          customerAccess['ID'] = existingObj.ID;
        }

        this.selectedCustomers.push(customerAccess);
      } else if (!ev.checked && result) {
        const removeIndex = this.selectedCustomers.findIndex((u1) => u1.CustomerID == ev.row.ID);
        this.selectedCustomers.splice(removeIndex, 1);
      }
    } else {
      const result = this.selectedAggregates.find((u1) => u1.AggregateID == ev.row.ID);
      const record = this.dataAccesses.Aggregates.find((u1) => u1.ID == ev.row.ID);

      if (ev.checked && !result) {
        const aggregateAccess = {
          CustomerID: null,
          AggregateID: record.ID,
          EnableSubCustomers: false,
        };

        this.selectedAggregates.push(aggregateAccess);
      } else if (!ev.checked && result) {
        const removeIndex = this.selectedAggregates.findIndex((u1) => u1.AggregateID == ev.row.ID);
        this.selectedAggregates.splice(removeIndex, 1);
      }
    }
  }

  checkDuplicateEmail() {
    this.genericService.GET(this.endpoints.CHECK_DUPLICATE_EMAIL(this.auth.GetUserID(), this.emailControl.value)).subscribe((resp) => {
      if (resp['body']) {
        this.emailControl.setErrors({ duplicate: true });
      } else {
        this.emailControl.setErrors(null);
      }
    });
  }

  subCustomerSelected(ev) {
    let i;
    for (i = 0; i < this.selectedCustomers.length; i++) {
      if (this.selectedCustomers[i].CustomerID == ev.row.ID) {
        break;
      }
    }
    this.selectedCustomers[i].EnableSubCustomers = ev.toggled;
  }

  cancel() {
    this.router.navigate([this.routes.UserManagement]);
  }

  updateUserRoles(ev) {
    this.selectedRoles = ev;
  }
}
